import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addModalOrderID, openPaymentModal, openOrderCloseModal } from '../actions/index';
import moment from 'moment';
import _ from 'lodash';

class OpenOrdersItems extends Component {

  handleCloseButton = (orderID) => {
    // open the close order modal
    this.props.addModalOrderID(orderID).then( () => {
      this.props.openOrderCloseModal();
    });
  }

  handlePayButton = (orderID) => {
    this.props.addModalOrderID(orderID).then( () => {
      this.props.openPaymentModal();
    });
  }

  // Take the props with all the open orders and display them in the table
  renderOrderItems() {
    var items = this.props.openOrders;

    return items.map( (item, index) => {

      // Decide which buttons to show for each order (Paid or un-paid)
      let buttons = '';
      if (item.order_paid) {
        buttons = (
          <td className="h4 text-xs-right">
            <button onClick={event => this.handleCloseButton(item.id)} className="btn btn-primary btn-lg waves-effect waves-light">CLOSE</button>
          </td>
        )
      } else {
        buttons = (
          <td className="h4 text-xs-right">
            <button className="btn btn-black btn-lg waves-effect waves-light">PRINT</button>
            &nbsp;
            <button onClick={event => this.handlePayButton(item.id)} className="btn btn-primary btn-lg waves-effect waves-light">PAY</button>
          </td>
        )
      }      

      return(
        <tr key={item.id}>
          <th className="h4 align-middle p-1">{moment(item.order_time_start).format('DD/MM/YY hh:mm:ss a')}</th>
          <td className="h4 align-middle p-1">{item.server_id}</td>
          <td className="h4 align-middle p-1">{item.order_name}</td>
          <td className="h4 align-middle p-1">${item.grandtotal.toFixed(2)}</td>
            { buttons }
        </tr>
      );
    });
  }

  render() {
    // If there are no open orders
    if (_.isEmpty(this.props.openOrders)) {
      return (
        <span>There are no open orders at this time.</span>
      );
    }

    return(
      <table className="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th className="h4">Time</th>
            <th className="h4" data-priority="6">ID</th>
            <th className="h4" data-priority="6">Name</th>
            <th className="h4" data-priority="1">Total</th>
            <th className="h4 text-xs-right" data-priority="1"></th>
          </tr>
        </thead>
        <tbody>
          {this.renderOrderItems()}
        </tbody>
      </table>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { addModalOrderID, openPaymentModal, openOrderCloseModal }, dispatch);
}

export default connect(null, mapDispatchToProps)(OpenOrdersItems);



// WEBPACK FOOTER //
// ./src/containers/open_orders_items.js